import { ReactNode } from "react";
import { Pagination } from "components/Pagination/Index";

import { SideBar } from "components/SideBar";

import { Wrapper } from "./style";

type Props = {
  children: ReactNode;
  containerClass?: string;
  hasTableWrapper?: boolean;
  page?: number;
  setPage?: React.Dispatch<React.SetStateAction<number>>;
  total?: number;
};

function DashboardTemplate({
  children,
  containerClass,
  hasTableWrapper = false,
  page,
  setPage,
  total,
}: Props) {
  return (
    <Wrapper>
      <SideBar />

      <div
        className={`
          ${"childrenContainer"} 
          ${hasTableWrapper && "tableWrapper"} 
          ${containerClass}
        `}
      >
        {children}
        {setPage && (
          <Pagination
            totalCountOfRegisters={total || 0}
            currentPage={page}
            onPageChange={setPage}
          />
        )}
      </div>
    </Wrapper>
  );
}

export { DashboardTemplate };
